import { render } from "./IssuancePage.vue?vue&type=template&id=7cc6e74a"
import script from "./IssuancePage.vue?vue&type=script&lang=js"
export * from "./IssuancePage.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__